import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { Observable, tap } from 'rxjs';
import { CategoriaMenuItem, ParametroConfiguracionService } from '../../../models/parametroEmpresa/parametro-configuracion.service';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';

@Component({
  standalone:true,
  imports:[CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    RouterModule,
    MatSelectModule,
    MatButtonModule,
    MatTooltipModule,
    MatDividerModule,
    MatListModule,
    MatIconModule,
    NgxSpinnerModule,],
  selector: 'app-nav-panel-configuracion',
  templateUrl: './nav-panel-configuracion.component.html',
  styleUrls: ['./nav-panel-configuracion.component.css']
})
export class NavPanelConfiguracionComponent implements OnInit {

  @Output() categoriaSeleccionadaEvent = new EventEmitter<CategoriaMenuItem>();

  categorias$: Observable<CategoriaMenuItem[]>;
  categoriaActivaRuta: string | null = null;
  isLoadingCategorias = true;

  constructor(
    private parametroConfigService: ParametroConfiguracionService,
    public router: Router
  ) {
    this.categorias$ = this.parametroConfigService.getCategorias().pipe(
      tap((categorias) => {
        this.isLoadingCategorias = false;
        // Seleccionar automáticamente la primera categoría si no hay ninguna seleccionada
        if (categorias && categorias.length > 0 && !this.categoriaActivaRuta) {
          setTimeout(() => {
            this.seleccionarCategoria(categorias[0]);
          }, 0);
        }
      })
    );
  }

  ngOnInit(): void {
    // La lógica de selección automática se maneja en el constructor
  }

  seleccionarCategoria(categoria: CategoriaMenuItem): void {
    this.categoriaActivaRuta = categoria.ruta;
    this.categoriaSeleccionadaEvent.emit(categoria);
  }
}
